import DonationAlert from './DonationAlert'
export default DonationAlert
